// This solution "hijacks" input element containers and uses AJAX to submit the data instead of doing
// a full postback.  In the Sitecore development environment, this was causing a viewstate validation
// error that could not be reproduced outside of Sitecore.  So the following workaround was implemented:
//
// 1) Set ASP.NET control ClientIDMode="static"
// 2) This script updates the "name" attribute of each input element to match its "id" attribute (add data-sync-name="false" to bypass this behavior)
// 3) The form handler checks for postback using Request.RequestType == "POST" and reads values as Request.Form[theControl.ClientID]

(function ($) {

	if (!$.fn.validate) {
		console.warn('jQuery Validation plugin not available.');
		return;
	}
	prepAjaxForm();
	bindEvents();
	initRequiredCheckboxes();

	var submitDelaySelector = "[data-delay-submit]",
		formSubmissionTimer = null,
		submitDelay;

	function bindEvents() {
		$('body')
			.on('show.bs.modal', '.ajax-form', function (e) {
				if (submitDelay) {
					initSubmissionDelay();
				}
				autoPopulate(e.target);
				captureInitialValues(e.target);
				initFormRadios(e.target);
				initValidation(e.target);
				resetForm(e.target);
				if (!$(this).data("modal-opened")) {
					$(this).data("modal-opened", "true");
					trackInitialTags($(this), "init");
				}
			})
			.on('shown.bs.modal', '.ajax-form', function (e) {
				setFocusToFirstField(e.target);
			})
			.on('hidden.bs.modal', '.ajax-form', function () {
				if ($("body").find(submitDelaySelector).length) {
					toggleFormSubmission(false);
				}
			})
			.on('click', '.ajax-form .form-submit', trackAnalytics)
			.on('change', '.ajax-form .checkboxes[data-required] input[type=checkbox]', function () {
				validRequiredCheckboxes($(this).closest(".checkboxes"));
			});

		// Track last field copmpleted by the user for the "comp_n" Analytics tag
		window.lastActiveField = "";
		$('.ajax-form').find("input, select, textarea").on("change", function (e) {
			var formName = $(this).data("ajax-form-name"),
                labelName = formName ? formName : $(this).siblings('label:not(.error)').text();
			labelName += $(this).is(":radio") ? "-" + $(this).val() : "";
			window.lastActiveField = ($(this).val() != "") ? labelName : "";
			trackAnalytics(e);
		});

		$(document).ready(function () {
			if ($("body").find(submitDelaySelector).length) {
				submitDelay = Object.freeze({
					get: $("body").find(submitDelaySelector).data("delay-submit")
				});
			}
		});
	}

	function prepAjaxForm() {
		setManualTag = function (elems, mode) {
			var data,
				$form,
				$elems = $('.ajax-form').find(elems.join(","));
			$elems.each(function () {
				data = {};
				$form = $(this).closest('.ajax-form');
				data = $(this).data("analytics");
				if (data) {
					data.manual = mode;
					$(this).attr("data-analytics", JSON.stringify(data));
				} else {
					if ($(this).is(".btn-close")) {
						data = $.extend({}, $form.find('.form-cancel').data("analytics"), { "csg": "Exit", "manual": mode });
						$(this).attr("data-analytics", JSON.stringify(data));
					}
				}
			});
		};
		var clusters = [
                {
                	elems: [
                        '.btn-close[data-bs-dismiss=modal]',
                        '.form-cancel',
                        '.form-submit',
						'input[type=radio]'
                	],
                	mode: false
                }
		];
		$.each(clusters, function (i, v) {
			setManualTag(v.elems, v.mode);
		});
		$('.ajax-form').each(function(i, v) {
			$(v).attr('data-bs-backdrop', 'static');
			$('<div class="modal-sending-backdrop" />').insertBefore($(v).find('.modal-footer'));
		});
	}

	// jQuery Validation plugin only works at the <form> level.  Since the XOM template has a single top-level form element,
	// use of this this plugin may affect validation of other fields outside the scope of this ajax-form element.
	function initValidation(target) {
		var form = $(target).closest('form');
		form.off('validate');
		form.data('validator', null);
		form
            .validate({
            	ignore: '' // jQuery Validation ignores hidden fields by default, and our custom radios hide the <input> element
            })
            .resetForm();
		$('.ajax-form').find('input, select, textarea').removeClass('error');
	}

	function autoPopulate(target) {
		var $target = $(target);
		var values = $target.data('formValues');
		if (!values) return;
		for (var k in values) {
			if (!values.hasOwnProperty(k)) continue;
			var field = $target.find('[data-ajax-form-name="' + k + '"]');
			var type = field.attr('type');
			if (type === 'checkbox' || type === 'radio') {
				field.filter('[value="' + values[k] + '"]').attr('checked', true);
			} else {
				field.val(values[k]);
			}
		}
	}

	function captureInitialValues(target) {
		getFields(target).each(function () {
			var $this = $(this);
			if ($this.data('initialValue') !== undefined) return;
			$this.data('initialValue', $this.is('[type="radio"],[type="checkbox"]') ? $this.is(':checked') : $this.val());
		});
	}

	function restoreInitialValues(target) {
		getFields(target).each(function () {
			var $this = $(this);
			var initialValue = $this.data('initialValue');
			if (initialValue === null) return;
			if ($this.is('[type="radio"],[type="checkbox"]')) {
				$this.attr('checked', initialValue);
				$this.removeClass("invalid");
			} else {
				$this.val(initialValue);
			}
		});
	}

	function resetForm(target) {
		var $target = $(target);
		$target.find('.form-submit,.form-cancel').removeClass('hidden');
		$target.find('.form-done, .form-sending').addClass('hidden');
		getFields(target).each(setNameToId);
		restoreInitialValues(target);
		window.lastActiveField = "";
		$("[data-required] p.error.visible").removeClass("visible");
		trackInitialTags($(this), "reset");
		show($target, 'body');
	}

	function trackInitialTags(form, mode) {
		var formButtons = form.find('.btn-close[data-bs-dismiss=modal], .form-cancel, .form-submit'),
			attr = mode === "init" ? "data-analytics-init" : "data-analytics",
			val = mode === "init" ? "data-analytics" : "data-analytics-init";
		formButtons.each(function () {
			$(this).attr(attr, $(this).attr(val));
		});
	}

	function setNameToId() {
		var $el = $(this);
		var id = $el.attr('id');
		if (!id || $el.data('syncName') === false) return;
		$el.attr('name', id);
	}

	function setFocusToFirstField(target) {
		getFields(target).first().focus();
	}

	function onSubmitRequested(e) {
		var $form = $(e.currentTarget).closest(".ajax-form");
		if (submitDelay) {
			if ( !$form.attr("data-submit-allowed") || formSubmissionTimer ) {
				return false;
			}
		}
        var data = $(e.currentTarget).data("analytics");
		$form.find(".checkboxes[data-required]").each(function () {
			validRequiredCheckboxes($(this));
		});
		if (getFields($form).valid() && !$form.find(".invalid").length) {
			submitForm($form, data);
		} else {
			var firstInvalid = $form.find("[aria-invalid=true], .invalid").first(),
				screenH = window.innerHeight,
				posY = (firstInvalid.offset().top + screenH / 2) + "px";
			$form.animate({ scrollTop: posY }, 500, "swing", function () {
				firstInvalid[0].focus();
			});
		}
	}

	function submitForm($form, WTData) {
		var action = $form.attr('data-form-action'),
            array = getFields($form).serializeArray(),
            submitButton = $form.find(".form-submit")[0];
			if ($form.find('.form-sending').length) {
				$form.find('.modal-sending-backdrop').addClass('show');
				$form.find('.form-sending').removeClass('hidden');
				$form.find('.form-submit').addClass('hidden');
			}
		processFormData($form, array);
		var json = JSON.stringify(serializeObject(array));
		$.ajax({ type: 'POST', contentType: 'application/json', url: action, data: json })
            .done(function (response, status, xhr) {
            	show($form, 'success');
            	if (typeof window.sendFloodlightOnSubmit === "function") {
            		window.sendFloodlightOnSubmit(submitButton);
            	}
            	if (xhr.status === 200 && WTData) {
            		var tracking = $form.find("[data-track-analytics]"),
                        trackVal = tracking.val();
            		if (tracking.length) {
            			WTData = $.extend({}, WTData, {
            				dcsuricust: "/" + trackVal,
            				tagtitle: trackVal
            			});
            		}
            		WTData = $.extend({}, WTData, {
            			zformtypeevent: 1,
            			csg: "Successful Submit"
            		});
            	}
            })
            .fail(function () { show($form, 'failure'); })
            .always(function () {
            	if ($form.find('.form-sending').length) {
            		$form.find('.modal-sending-backdrop').removeClass('show');
            		$form.find('.form-sending').addClass('hidden');
            	}
            	$form.find('.form-submit').addClass('hidden');
            	$form.find('.form-cancel').addClass('hidden');
            	$form.find('.form-done').removeClass('hidden');
            });
	}

	function getFields(target) {
		return $(target).find('input,textarea,select');
	}

	function processFormData($form, array) {
		$.each(array, function () {
			var ajaxFormName = $form.find('[name="' + this.name + '"]').data('ajaxFormName');
			if (ajaxFormName) this.name = ajaxFormName;
			this.value = escapeInputValue( this.value );
		});
	}

	function show($container, partial) {
		var partials = ['body', 'success', 'failure'];
		for (var i = 0; i < partials.length; i++) {
			var on = (partial === partials[i]);
			$container.find('.form-' + partials[i])[on ? 'removeClass' : 'addClass']('hidden');
		}
	}

	function serializeObject(array) {
		var o = {};
		$.each(array, function () {
			if (o[this.name] !== undefined) {
				if (!o[this.name].push) {
					o[this.name] = [o[this.name]];
				}
				o[this.name].push(this.value || '');
			} else {
				o[this.name] = this.value || '';
			}
		});
		return o;
	}

	function trackAnalytics(e) {
		e.preventDefault();
		var $form = $(e.target).closest('.ajax-form');
		if ($(e.target).hasClass("form-submit")) {
			onSubmitRequested(e);
		} else {
			updateWTAnalytics($form);
		}
	}
	function updateWTAnalytics($form) {
		var trackButtons = [
            '.btn-close[data-bs-dismiss=modal]',
            '.form-cancel',
            '.form-submit'
		];
		var fields = $form.find('input:not("[type=button], [type=hidden]"), select, textarea'),
            totalFields = fields.length,
             completedFields = fields.filter(function () {
             	if ($(this).is(':radio') || $(this).is(":checkbox")) {
             		return this.checked;
             	}
             	return this.value;
             }),
            reqFields = $form.find("[required]").length,
            reqCompletedFields = completedFields.filter(function () {
            	return $(this).prop("required") || $(this).closest("[data-required]").length > 0;
            }).length,
            WTData = {};
		$form.find("[data-required]").each(function () {
			var reqNum = parseInt($(this).data("required"), 10);
			reqFields += isNaN(reqNum) ? 1 : reqNum;
		});
		$($form.find(trackButtons.join(","))).each(function () {
			WTData = $.extend($(this).data("analytics"), {
				compn: window.lastActiveField,
				filltxt: completedFields.length,
				numfields: totalFields
			});
			if ($(this).hasClass("form-submit")) {
				WTData.manual = reqCompletedFields === reqFields;
				delete WTData.sc_goals;
			}
			$(this).attr("data-analytics", JSON.stringify(WTData));
		});
	}

	function initRequiredCheckboxes() {
		var numRequired,
			spanText = " option";
		boxGroups = $(".ajax-form .checkboxes[data-required]").each(function (i, v) {
			numRequired = $(v).data("required");
			spanText += numRequired > 1 ? "s" : "";
			$(v).find(".error span").text(numRequired + spanText);
		});
	}

	function validRequiredCheckboxes(fgroup) {
		var numRequired = fgroup.data("required"),
			inputs = fgroup.find("input"),
			labels = fgroup.find("input + label"),
			checkedInputs = fgroup.find("input").filter(function () {
				return $(this).is(":checked");
			}),
			numChecked = checkedInputs.length,
			validRule = numChecked >= numRequired;
		inputs[validRule ? 'removeClass' : 'addClass']('invalid').attr("aria-invalid", !validRule);
		fgroup.find("p.error")[validRule ? 'removeClass' : 'addClass']('visible');
	}

	function escapeInputValue(val) {
		return $.fn.xss.sanitize(val);
	}

	function initSubmissionDelay() {
		if (submitDelay === undefined) return false;
		toggleFormSubmission(false);
		clearTimeout(formSubmissionTimer);
		formSubmissionTimer = null;
		formSubmissionTimer = setTimeout(function (){
			formSubmissionTimer = null;
			toggleFormSubmission(true);
		}, submitDelay.get);
	}

	function toggleFormSubmission(state) {
		$forms = $(".ajax-form");
		var submitAllowed = $forms.attr("data-submit-allowed");
		$forms.attr("data-submit-allowed", state ? "true" : "");
		$forms.find(".form-submit")[state ? "removeAttr" : "attr"]("disabled", "");
	}

	function initFormRadios(target) {
		var $form = $(target),
			radioComps = $form.find(".component[data-required]");
		radioComps.each(function(i, comp) {
			$(comp).find("label.error").attr("for", $(comp).find("input:first").attr("name") );
		});
	}

}(window.jQuery));

(function ($) {
    $("body[data-row-styles] input[type=checkbox]").change(function () {
        if ($(this).is(':checked')) {
            $(this).parent().addClass('active');
        } else {
            $(this).parent().removeClass('active');
        }
        
    });

    var row_radio_inputs = $('body[data-row-styles] .radio-buttons label input');

    row_radio_inputs.each(function () {
        if ($(this).is(':checked')) {
            $(this).parent().addClass('active');
        }

    });

    $('body[data-row-styles]').on("change", ".radio-buttons label input", function () {
        $(this).parents(".radio-buttons").find("label").removeClass('active');
        $(this).parent().addClass('active');
    });

}(window.jQuery));



$(document).ready(function () {
    $feedbackLinks = $('.promotion-share-link');
    if (!$feedbackLinks.length) return false;
    $feedbackLinks.on('click', function () {
        var textToReplace = $('.screen-title-title').text();
        if (textToReplace == 'undefined' || textToReplace == '') {
            textToReplace = document.title != '' ? document.title : '';
        }
        var modalHeading = $('#prodNameLabel').text().replace('{prodNameLabel}', textToReplace);
        $('#prodNameLabel').text(sanitizeHtmlStrings(modalHeading));

        if ($("textarea[data-sc-field-name='txtSubject']") && $("textarea[data-sc-field-name='txtSubject']").length > 0) {
            $("textarea[data-sc-field-name='txtSubject']").text(sanitizeHtmlStrings(textToReplace));
        } else {
            $("input[data-sc-field-name='txtSubject']").val(sanitizeHtmlStrings(textToReplace));
        }
        var txtSubjectSection = $('.txtSubject_section');
        if (txtSubjectSection !== 'undefined' && txtSubjectSection.length > 0) {
            txtSubjectSection.text(sanitizeHtmlStrings(textToReplace));
        }
    });
});

// for chemical share this page
$(document).ready(function () {
    $chemicalFormsLinks = $('[data-bs-target="#Sharethispage"]');
    if (!$chemicalFormsLinks.length) return false;
    $chemicalFormsLinks.on('click', function (e) {
        var dynamicText = '{prodNameLabel}';
        var headingElement = $('.b06-heading h3');
        var textToReplace = "";
        if (headingElement.length == 0) {
            headingElement = $('.screen-title-title.field-title');
        }
        if (headingElement && headingElement.length) {
            textToReplace = $(headingElement).text();
        }
        if (textToReplace == 'undefined' || textToReplace == '') {
            textToReplace = document.title != '' ? document.title : '';
        }
        var headingHtml = $('#Sharethispage #prodNameLabel').html();
        if (headingHtml && headingHtml.indexOf(dynamicText) > -1) {
            $('#Sharethispage #prodNameLabel').html(sanitizeHtmlStrings(headingHtml.replace('{prodNameLabel}', '<span class="dynamic-text">' + textToReplace + '</span>')));
        } else {
            $('#Sharethispage #prodNameLabel').find('.dynamic-text').text(sanitizeHtmlStrings(textToReplace));
        }

        if ($("#Sharethispage textarea[data-sc-field-name='txtSubject']") && $("#lightbox-share textarea[data-sc-field-name='txtSubject']").length > 0) {
            $("#Sharethispage textarea[data-sc-field-name='txtSubject']").text(sanitizeHtmlStrings(textToReplace));
        } else {
            $("#Sharethispage input[data-sc-field-name='txtSubject']").val(sanitizeHtmlStrings(textToReplace));
        }
        var txtSubjectSection = $('.txtSubject_section');
        if (txtSubjectSection !== 'undefined' && txtSubjectSection.length > 0) {
            txtSubjectSection.text(sanitizeHtmlStrings(textToReplace));
        }
    });
});

// Share options in the custom list
$(document).ready(function () {
    var dynamicText = '{prodNameLabel}';
    $feedbackLinks = $('[data-bs-target="#shareform01"][data-bs-toggle="modal"]:not(.pds-share-link)');
    if (!$feedbackLinks.length) return false;
    $feedbackLinks.on('click', function (e) {
        if ($(e.currentTarget).length && $(e.currentTarget).parents(".div-table-row").length) {
            var headingHtml = $('#shareform01 #prodNameLabel').html();
            var temp = $(e.currentTarget).parents(".div-table-row").find(".resource-list-description .field-description");
            var pdfName = temp.length > 0 ? $(temp[0]).text() : '';
            if (pdfName == 'undefined' || pdfName == '') {
                pdfName = document.title != '' ? document.title : '';
            }
            if (headingHtml.indexOf(dynamicText) > -1) {
                $('#shareform01 #prodNameLabel').html(sanitizeHtmlStrings(headingHtml.replace('{prodNameLabel}', '<span class="dynamic-text">' + pdfName + '</span>')));
            } else {
                $('#shareform01 #prodNameLabel').find('.dynamic-text').text(sanitizeHtmlStrings(pdfName));
            }
            //$("#shareform01 input[data-sc-field-name='txtSubject']").val(pdfName);
            if ($("#shareform01 textarea[data-sc-field-name='txtSubject']") && $("#shareform01 textarea[data-sc-field-name='txtSubject']").length > 0) {
                $("#shareform01 textarea[data-sc-field-name='txtSubject']").text(sanitizeHtmlStrings(pdfName));
            } else {
                $("#shareform01 input[data-sc-field-name='txtSubject']").val(pdfName);
            }
            var txtSubjectSection = $('.txtSubject_section');
            if (txtSubjectSection !== 'undefined' && txtSubjectSection.length > 0) {
                txtSubjectSection.text(sanitizeHtmlStrings(pdfName));
            }
            var shareUrl = '';
            var domain = '';
            var protocol = '';
            var siteUrl = '';
            siteUrl = window.location.href.split('/');
            domain = siteUrl[2]; protocol = siteUrl[0];
            //protocol = window.location.href;
            var linkElement = $(e.currentTarget).parents(".div-table-row").find('a[title*="File"]').eq(0);
            if (linkElement == 'undefined' || linkElement.length <= 0) {
                linkElement = $(e.currentTarget).parents(".div-table-row").find('a').eq(0);
            }
            if (linkElement && linkElement != 'undefined') {
                shareUrl = $(linkElement).attr('href');
                if ($("input[data-sc-field-name='shareDocumentUrl']") != 'undefined') {
                    $("input[data-sc-field-name='shareDocumentUrl']").val(protocol + "//" + domain + shareUrl);
                }
            } else {
                linkElement = $(this).closest('.div-table-row').find('[title="File"]').eq(2);
                if (linkElement == 'undefined' || linkElement.length <= 0) {
                    linkElement = $(e.currentTarget).parents(".div-table-row").find('[title="File_1"]').eq(2);
                }
                if (linkElement && linkElement != 'undefined') {
                    shareUrl = $(linkElement).attr('href');
                    if ($("input[data-sc-field-name='shareDocumentUrl']") != 'undefined') {
                        $("input[data-sc-field-name='shareDocumentUrl']").val(protocol + "//" + domain + shareUrl);
                    }
                }
            }
        }
    });
});


// Share to a collegue
$(document).ready(function () {
    var dynamicText = '{prodNameLabel}';
    $feedbackLinks = $('[data-bs-target="#lightbox-share"]');
    if (!$feedbackLinks.length) return false;
    $feedbackLinks.on('click', function (e) {
        var headingElement = $('.b06-heading h1');
        var textToReplace = "";
        if ($(this).hasClass('ides-share-link')) {
            textToReplace = $(e.target).closest('tr').find('td .ides-subject').text().trim();
            $('.PDSurlHidden').val($(e.target).closest('tr').find('.ides-pds-link').attr('href'));
            $('.Sales-specURLHidden').val($(e.target).closest('tr').find('.ides-sales-spec-link').attr('href'));
        }
        if (headingElement.length == 0) {
            headingElement = $('.screen-title-title.field-title');
        }
        if ((textToReplace == 'undefined' || textToReplace == '') && headingElement && headingElement.length) {
            textToReplace = $(headingElement).text();
        }
        if (textToReplace == 'undefined' || textToReplace == '') {
            textToReplace = document.title != '' ? document.title : '';
        }
        var headingHtml = $('#lightbox-share #prodNameLabel').html();
        if (headingHtml && headingHtml.indexOf(dynamicText) > -1) {
            $('#lightbox-share #prodNameLabel').html(sanitizeHtmlStrings(headingHtml.replace('{prodNameLabel}', '<span class="dynamic-text">' + textToReplace + '</span>')));
        } else {
            $('#lightbox-share #prodNameLabel').find('.dynamic-text').text(sanitizeHtmlStrings(textToReplace));
        }

        if ($("#lightbox-share textarea[data-sc-field-name='txtSubject']") && $("#lightbox-share textarea[data-sc-field-name='txtSubject']").length > 0) {
            $("#lightbox-share textarea[data-sc-field-name='txtSubject']").text(sanitizeHtmlStrings(textToReplace));
        } else {
            $("#lightbox-share input[data-sc-field-name='txtSubject']").val(sanitizeHtmlStrings(textToReplace));
        }
        var txtSubjectSection = $('.txtSubject_section');
        if (txtSubjectSection !== 'undefined' && txtSubjectSection.length > 0) {
            txtSubjectSection.text(sanitizeHtmlStrings(textToReplace));
        }
    });
});

$(document).ready(function () {
    var textToReplace = '';
    $feedbackLinks = $('.product-share-link');
    if (!$feedbackLinks.length) return false;
    $feedbackLinks.off('click').on('click', function () {
        var dynamicText = '{prodNameLabel}';
        var headingElement = $('[pds-heading]');
        var recommendationName = $('[recommendation-name]');
        var equipmentHeading = $('.special-screen-title-text h1');
        var fieldTitle = $('.field-title');
        if (typeof (headingElement) !== "undefined" && headingElement.length > 0) {
            textToReplace = $(headingElement).attr('pds-heading');
        }
        else {
            textToReplace = $('.screen-title-title.field-title').text();
        }
        if (typeof (recommendationName) !== "undefined" && recommendationName.length > 0) {
            textToReplace = $(recommendationName).attr('recommendation-name');
        }
        if (typeof (equipmentHeading) !== "undefined" && equipmentHeading.length > 0) {
            textToReplace = $(equipmentHeading).text();
        }
        if (textToReplace == 'undefined' || textToReplace == '' && typeof (fieldTitle) !== "undefined" && fieldTitle.length > 0) {
            //taking the first value from the list as product page has so many .field-title classes
            textToReplace = $($(fieldTitle)[0]).text();
        }
        if (textToReplace == 'undefined' || textToReplace == '') {
            textToReplace = document.title != '' ? document.title : '';
        }
        var headingHtml = $('#prodNameLabel').html();
        if ($("input[data-sc-field-name='shareDocumentUrl']") != 'undefined') {
            $("input[data-sc-field-name='shareDocumentUrl']").val('');
        }
        if (headingHtml && headingHtml.indexOf(dynamicText) > -1) {
            $('#prodNameLabel').html(sanitizeHtmlStrings(headingHtml.replace(dynamicText,
                '<span class="dynamic-text">' + textToReplace + '</span>')));
        } else {
            $('#prodNameLabel').find('.dynamic-text').text(sanitizeHtmlStrings(textToReplace));
        }
        if ($("textarea[data-sc-field-name='txtSubject']") && $("textarea[data-sc-field-name='txtSubject']").length > 0) {
            $("textarea[data-sc-field-name='txtSubject']").text(sanitizeHtmlStrings(textToReplace));
        } else {
            $("input[data-sc-field-name='txtSubject']").val(textToReplace);
        }
        var txtSubjectSection = $('.txtSubject_section');
        if (txtSubjectSection !== 'undefined' && txtSubjectSection.length > 0) {
            txtSubjectSection.text(sanitizeHtmlStrings(textToReplace));
        }
        setTimeout(function () {
            $(".modal.fade.show .sitecore-form .form-area input.form-control").first().focus();
        }, 1000);
    });
});

$('body').on('click', '.sfmc-form-databind',
    function () {
        var model = "";
        var engine = "";
        var make = "";
        var year = "";
        var URL = window.location.href;
        var pageTitle = $(document).attr('title');
        $('.product-selector-pageurl').val(URL);
        $('.product_locator_pagetitle').val(pageTitle);
        var dataAttr = $('.product-selector').attr("data-app-config");
        var modelAttr = $('.recommendations-view').attr("data-vehicleprofile");
        if (dataAttr !== undefined && modelAttr !== undefined) {
            var appConfig = JSON.parse(dataAttr);
            var modelConfig = JSON.parse(modelAttr);
            var provider = appConfig.data.providerKey;
            if (provider == 'WMI') {
                model = modelConfig.model;
                make = modelConfig.manufacturer;
                engine = modelConfig.engine;
                year = modelConfig.year_to;
            }
            else if (provider == 'Motor') {
                var itemsArray = window.location.href.split('/');
                model = itemsArray[itemsArray.length - 1];
                make = itemsArray[itemsArray.length - 2];
                year = itemsArray[itemsArray.length - 3].split('-').pop();
                engine = appConfig.response.body.attributes.engines[0].description;
            } else {
                model = modelConfig.model;
                make = modelConfig.manufacturer;
                engine = modelConfig.model + " " + modelConfig.fuel;
                year = modelConfig.year_from;
            }
            $('.product-selector-model').val(model);
            $('.product-selector-make').val(make);
            $('.product-selector-engine').val(engine);
            $('.product-selector-year').val(year);

            $('.product-selector-isproduct').val("");
            $('.product-selector-productname').val("");
            $('.product-selector-ph6code').val("");
        }
    }
);

$('body').on('click', '.btn-remind-ps',
    function () {
        var model = "";
        var engine = "";
        var make = "";
        var year = "";
        var URL = window.location.href;
        var dataAttr = $('.product-selector').attr("data-app-config");
        var appConfig = JSON.parse(dataAttr);
        var modelAttr = $('.recommendations-view').attr("data-vehicleprofile");
        var modelConfig = JSON.parse(modelAttr);
        var provider = appConfig.data.providerKey;
        if (provider == 'WMI') {
            model = modelConfig.model;
            make = modelConfig.manufacturer;
            engine = modelConfig.engine;
            year = modelConfig.year_to;
        } else {
            model = modelConfig.model;
            make = modelConfig.manufacturer;
            engine = modelConfig.model + " " + modelConfig.fuel;
            year = modelConfig.year_from;
        }

        var productsAttr = $('.ps-products-view').attr("data-products");
        var productsConfig = JSON.parse(productsAttr);
        var gpnval = $(this).attr('ps-gpn');
        var product = productsConfig.find(function (product, index) {
            if (product.gpn == gpnval) return true;
        });

        var isProduct = true;
        var productName = product.name;

        var pageTitle = $(document).attr('title');

        $('.product-selector-isproduct').val(isProduct);
        $('.product-selector-productname').val(productName);
        $('.product-selector-ph6code').val(gpnval);

        $('.product-selector-model').val(model);
        $('.product-selector-make').val(make);
        $('.product-selector-engine').val(engine);
        $('.product-selector-year').val(year);
        $('.product-selector-pageurl').val(URL);
        $('.product_locator_pagetitle').val(pageTitle);
    }
);

$('body').on('click', '.recommendations-header .link-modal',
    function () {
        var model = "";
        var engine = "";
        var make = "";
        var year = "";
        var URL = window.location.href;
        var dataAttr = $('.product-selector').attr("data-app-config");
        var appConfig = JSON.parse(dataAttr);
        var modelAttr = $('.recommendations-view').attr("data-vehicleprofile");
        var modelConfig = JSON.parse(modelAttr);
        var provider = appConfig.data.providerKey;
        if (provider == 'WMI') {
            model = modelConfig.model;
            make = modelConfig.manufacturer;
            engine = modelConfig.engine;
            year = modelConfig.year_to;
        } else {
            model = modelConfig.model;
            make = modelConfig.manufacturer;
            engine = modelConfig.model + " " + modelConfig.fuel;
            year = modelConfig.year_from;
        }

        var productsAttr = $('.ps-products-view').attr("data-products");
        var productsConfig = JSON.parse(productsAttr);

        $('.product-selector-model').val(model);
        $('.product-selector-make').val(make);
        if ($('.product-selector-engine')) {
            $('.product-selector-engine').val(engine);
        }
        $('.product-selector-year').val(year);
    }
);

(function () {
    var URL = window.location.href;
    var pageTitle = $(document).attr('title');
    if ($('.product-selector-pageurl') && $('.product-selector-pageurl').length) {
        $('.product-selector-pageurl').val(URL);
    }
    if ($('.product_locator_pagetitle') && $('.product_locator_pagetitle').length) {
        $('.product_locator_pagetitle').val(pageTitle);
    }
}(window.jQuery));

$(window).on('load', function () {
    if ($('.bv-focusable') && $('.bv-focusable').length) {
        $("span").parent(".bv-focusable").attr("role", "presentation");
    }
});

(function ($) {
    var url = $("input.postalcode").attr('data-api-url');
    var classname = $("input.postalcode").attr('data-target-binding-class');
    var errmsg = $("input.postalcode").attr('data-api-errormessage');
    $(".api-errormessage").css('display', 'none');
    $(".api-errormessage").html(errmsg);
    $(".api-errormessage").addClass('field-validation-error');
    $("input.postalcode").keyup(function () {
        var inputvalue = $(this).val();
        var apiurl = url;
        apiurl = apiurl.replace("{0}", inputvalue);
        var isvalid = (/^[0-9]{6}$/.test(inputvalue));
        if (inputvalue.length == 6 && isvalid) {
            $.ajax({
                type: 'GET',
                url: apiurl,
                success: function (data, status, xhr) {
                    if (data.results.length > 0) {
                        var value = data.results[0].BLK_NO + ' ' + data.results[0].ROAD_NAME;
                        $("input." + classname).val(value);
                        $("input." + classname).focus();
                        $(".api-errormessage").css('display', 'none');
                        $(".api-errormessage").removeClass('invalid-field');
                        $('.form-submit').removeAttr('disabled');
                    } else {
                        $("input." + classname).val('');
                        $(".api-errormessage").css('display', 'block');
                        $(".api-errormessage").addClass('invalid-field');
                    }
                }
            });
        } else {
            $("input." + classname).val('');
        }
    });
}(window.jQuery));



//Embedded PDF GTM Event Start
$('.pdfbtn').on("click", function (e) {
    e.preventDefault();
    var eleClass = $(this).attr("class");
    var parentele = event.srcElement.closest('.ld-pdfrender');
    var assetTitle = parentele.getAttribute('data-gtmdocumenttitle');
    var buType = parentele.getAttribute('data-gtmbusinessline');
    var eventAction = "Library PDF Preview";
    if (eleClass.includes("zoomctrl")) { eventAction = "Library PDF Zoom"; }
    var gtmData = {
        'event': 'gaCustomEvents_PDF_interactions',
        'eventCategory': 'Customer Enablement & Education',
        'eventAction': eventAction,
        'eventLabel': parentele.getAttribute('data-gtmassetid'),
        'document_title': assetTitle,
    };
    GTMDatalayerPush(gtmData, buType, assetTitle)
});

var scrollTwentyFiveV = true,
    scrollFiftyV = true,
    scrollSeventyFiveV = true,
    scrollNightyV = true,
    scrollTwentyFiveH = true,
    scrollFiftyH = true,
    scrollSeventyFiveH = true,
    scrollNightyH = true;
function embeddedPDFScrollCtrlGTM() {
    var ele = event.srcElement;
    var parentele = event.srcElement.closest('.ld-pdfrender');
    var scrollV = (ele.scrollTop / (parentele.clientHeight - ele.clientHeight)) * 10;
    var scrollH = (ele.scrollLeft / (parentele.clientWidth - ele.clientWidth)) * 10;
    var assetTitle = parentele.getAttribute('data-gtmdocumenttitle');
    var buType = parentele.getAttribute('data-gtmbusinessline');
    var gtmData = {
        'event': 'gaCustomEvents_PDF_interactions',
        'eventCategory': 'Customer Enablement & Education',
        'eventAction': 'Library PDF Scroll',
        'eventLabel': parentele.getAttribute('data-gtmassetid'),
        'document_title': assetTitle,
    };
    // Conditional code we'll use to fire events based on scrollPercentage vertical.
    if (scrollV >= 25 && scrollTwentyFiveV) {
        // Do something for 25% scroll
        scrollTwentyFiveV = false;
        GTMDatalayerPush(gtmData, buType, assetTitle)
    }
    if (scrollV >= 50 && scrollFiftyV) {
        // Do something for 50% scroll
        scrollFiftyV = false;
        GTMDatalayerPush(gtmData, buType, assetTitle)
    }
    if (scrollV >= 75 && scrollSeventyFiveV) {
        // Do something for 75% scroll
        scrollSeventyFiveV = false;
        GTMDatalayerPush(gtmData, buType, assetTitle)
    }
    if (scrollV >= 90 && scrollNightyV) {
        // Do something for 90% scroll (bottom of page)
        scrollNightyV = false;
        GTMDatalayerPush(gtmData, buType, assetTitle)
    }
    //Conditional code we'll use to fire events based on scrollPercentage Horizontal.
    if (scrollH >= 25 && scrollTwentyFiveH) {
        // Do something for 25% scroll
        scrollTwentyFiveH = false;
        GTMDatalayerPush(gtmData, buType, assetTitle)
    }
    if (scrollH >= 50 && scrollFiftyH) {
        // Do something for 50% scroll
        scrollFiftyH = false;
        GTMDatalayerPush(gtmData, buType, assetTitle)
    }
    if (scrollH >= 75 && scrollSeventyFiveH) {
        // Do something for 75% scroll
        scrollSeventyFiveH = false;
        GTMDatalayerPush(gtmData, buType, assetTitle)
    }
    if (scrollH >= 90 && scrollNightyH) {
        // Do something for 90% scroll (bottom of page)
        scrollNightyH = false;
        GTMDatalayerPush(gtmData, buType, assetTitle)
    }
}

////Distributor GTM Event for External link Start
function GTMDistributorDetailsExternalMapClick(link) {
    var gtmDistributorExternalLink = {
        "componentId": "sp01",
        "componentName": "map",
        "elementType": "locator map",
        "event": "locator",
        "eventType": "map pin click",
        "searchSubType": "",
        "searchTerm": "",
        "searchType": "",
        'event1': 'gaCustomEvents_distributor_locator',
        'eventCategory': 'Customer Enablement & Education',
        'eventAction': 'Visited Distributor Site',
        'eventLabel': link,
        'external_url': link,
        'page_type': 'Distributor Page',
        'page_title': 'Distributor Locator',
        'page_bu': pageVariables.BusinessUnit,
        'environment': pageVariables.Environment,
        'page_language': pageVariables.SiteLanguage,
        'sitecore_contact_id': pageVariables.SitecoreContactId,
        'pardot_cookie_id': pageVariables.PardotCookieId
    };
   dataLayer.push(gtmDistributorExternalLink);
}

// Common Parameters for all GTM Event Start
function GTMDatalayerPush(GTMDynamicData, buType, assetTitle) {

    if (typeof buType === "undefined") {
        var GTMPageBU = pageVariables.BusinessUnit;
    }
    else {
        var GTMPageBU = buType;
    }
    if (typeof assetTitle === "undefined") {
        var GTMPageTitle = pageVariables.PageTitle;
    }
    else {
        var GTMPageTitle = assetTitle;
    }

    var GTMCommonData = {
        'page_type': pageVariables.PageCategory,
        'page_title': GTMPageTitle,
        'page_bu': GTMPageBU,
        'environment': pageVariables.Environment,
        'page_language': pageVariables.SiteLanguage,
        'sitecore_contact_id': pageVariables.SitecoreContactId,
        'pardot_cookie_id': pageVariables.PardotCookieId
    };

    var GTMData = $.extend(GTMDynamicData, GTMCommonData);
    dataLayer.push(GTMData);
}

// Returns the assetID for EventLabel property for Library Asset downloads
function GetLibraryAssetIdForDownloadEvent(hrefAttr) {
    var assetId = undefined;
    if (hrefAttr.split(/[\s/]+/)[3]) {
        assetId = hrefAttr.split(/[\s/]+/)[3];
        if (assetId.split('-')[0]) {
            assetId = assetId.split('-')[0]
        }
    }
    return assetId;
}


function encodeTextareaValue(txtelement) {
    var txtval = txtelement.val();
    var utf16 = [];
    if (txtval != "" && txtval != undefined) {
        for (var i = 0, strLen = txtval.length; i < strLen; i++) {
            utf16.push(('000' + (parseInt(txtval.charCodeAt(i), 10).toString(16))).slice(-4));
        }
        txtelement.val(utf16.join("u"));
    }
}


// Changing decode code to decode chinese, english and spanish fonts
function decodeTextareaValue(txtareaelement) {
    if (txtareaelement != undefined) {
        var textareaval = txtareaelement.val();
        if (textareaval != "" && textareaval != undefined) {
            var textArr = textareaval.split("u");
            var decodedText = "";
            if (textArr != undefined) {
                for (var i = 0; i < textArr.length; i++) {
                    var hexValue = textArr[i];
                    if (hexValue !== "") {
                        var charCode = parseInt(hexValue, 16);
                        decodedText += String.fromCharCode(charCode);
                    }
                }
                txtareaelement.val(decodedText);
            }
        }
    }
}

function checkUndefined(value) {
    if (typeof value === "undefined") {
        value = "";
    }
    return value;
}
var formTokenManager = (function () {
    var config = {
        tokenFieldName: "__RequestVerificationToken",
        apiEndpoint: "/api/forms/GetAntiforgeryToken"
    };

    function formTokenManager() { }

    formTokenManager.prototype.init = function () {
        var self = this;
        if (document.getElementsByName(config.tokenFieldName).length > 0) {
            self.fetchToken();
        }
    };

    formTokenManager.prototype.fetchToken = function () {
        var self = this;
        fetch(config.apiEndpoint, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then(function (res) {
                return res.json();
            })
            .then(function (data) {
                self.updateTokenField(data.Value);
            })
            .catch(function (err) {
                //console.error("Error fetching the token:", err);
            });
    };

    formTokenManager.prototype.updateTokenField = function (tokenValue) {
        var tokenElements = document.getElementsByName(config.tokenFieldName);
        if (tokenElements.length > 0) {
            for (var i = 0; i < tokenElements.length; i++) {
                tokenElements[i].value = tokenValue;
            }
        }
    };

    return formTokenManager;
})();

$(document).ready(function () {
    var tokenManager = new formTokenManager();
    tokenManager.init();
});

(function ($) {
    var formInputs = 'input:not([type=hidden], [type=checkbox], [type=radio]), textarea';
    var hiddenInputs = 'input[type=hidden]';
    var videoId = [];
    var a14target = "";
    var a14TargetElem = "";
    $(document).ready(function () {
        bindEvents();
        wrapInputs();
        prepRequiredFields();
        modalFormReset();

        var textareaData = $('.ContactFormChemicals .encode-multiline');
        if (textareaData !== undefined) {
            // Get the values from data attributes
            var maxLength = parseInt(textareaData.data('val-length-max'));
            if (!isNaN(maxLength)) {
                var newMaxLength = Math.floor(maxLength / 5);
                var originalMessage = textareaData.data('val-length');
                if (originalMessage !== undefined) {
                    var newMessageLength = originalMessage.replace(maxLength.toString(), newMaxLength.toString());
                    textareaData.attr('data-val-length', newMessageLength);
                }
            }
        }
    });
    // for quick link component 
    $(".commitmentBoxes").hover(function () {
        $(this).parent().parent().toggleClass("commitmenthover-item");
    });
    // close autocomple and multiselect dropdown on clickoutside
    $(document).click(function (e) {
        $('.dropdown.multiselect')
            .not($('.dropdown.multiselect').has($(e.target)))
            .children('.dropdown-content')
            .removeClass('show');
    });

    $(document).click(function (e) {
        $('.dropdown.autocomplete')
            .not($('.dropdown.autocomplete').has($(e.target)))
            .children('.dropdown-content')
            .removeClass('show');
    });

    // we chat popup in left floating bar

    $(function () {
        var left_right_margin = -$('.floating-bar').height() / 2,
            top_bottom_margin = -$('.floating-bar').width() / 2;

        $('.floating-bar-right,.floating-bar-left').css({
            'margin-top': left_right_margin
        });

        $('.floating-bar-top,.floating-bar-bottom').css({
            'margin-left': top_bottom_margin
        });
    });

    $('.follow-wechat-section').click(function (e) {
        $('.wechat-light-box').hide();
        var target = $(this).attr('data-bs-target');
        $('#' + target).show();
        return;
    });

    $(".wechat-light-box .close-button").click(function (e) {
        var id = $(this).parent().attr('id');
        $('#' + id).hide();
        e.stopPropagation();
    });

    // anchor navigation active option 
    $(function () {
        $('.Anchor-Navigation .handle').on('mouseover', function (e) {
            $('#wechat-light-box').hide();
            $('#qrBox').hide();
            $(this).addClass('active');
            e.stopPropagation();
        });

        $('.Anchor-Navigation .handle').on('mouseleave', function (e) {
            var el = $(this);
            setTimeout(function () {
                if (!$(".Anchor-Navigation .handle:hover").length && !$(".Anchor-Navigation .handle ul:hover").length) {
                    el.removeClass('active');
                }
            }, 500);
            e.stopPropagation();
        });

        $('.Anchor-Navigation ul').on('mouseleave', function () {
            $(this).parent('.handle').removeClass('active');
            if ($('.Anchor-Navigation ul').css('display') === 'none') {
                $('.Anchor-Navigation li').removeClass('active');
            }
        });

        $('.Anchor-Navigation li').on('click', function () {
            $(this).addClass('active');
            $(this).siblings().removeClass('active');
        });
    });

    //contact us GTM 
    var errorlst = "";
    var SitecoreContactID = "";
    $(document).ready(function () {
        document.addEventListener('readystatechange', function (event) {
            if (event.target.readyState === "complete") {
                decodeTextareaValue($(".ContactFormChemicals textarea[data-sc-field-name=description]"));
            }
        });

    });
    $(document).on('click', '.ContactFormChemicals .PrimaryButtonID', function () {
        if ($(".dropdown").hasClass("country-field")) {
            var countryData = $('.country-field input').attr("id");
            var countryDropDown = $('.country-field .dropdown-content').attr("id");
            checkValidSearch(countryData, countryDropDown);
        }
        if ($(".ContactFormChemicals").find("input,textarea,select").valid()) {
            var ContactFormData = $('.ContactFormChemicals .encode-multiline');
            if (ContactFormData !== undefined) {
                var multiLineLengthval = ContactFormData.val().length;
                var maxcharLength = Math.floor(ContactFormData.attr("data-val-length-max") / 5);
                if (multiLineLengthval !== undefined && !isNaN(maxcharLength)) {
                    if (multiLineLengthval <= maxcharLength) {
                        encodeTextareaValue(ContactFormData);
                        ContactFormData.css("display", "none");
                        attachEventHandler(".component.sitecore-form", "OnChemicalsFormSuccessfulSubmit", SitecoreContactID);
                    }
                    else {
                        encodeTextareaValue(ContactFormData);
                        ContactFormData.css("color", "transparent");
                        setTimeout(checkMsgLength, 100);
                    }
                }
            }
        }
        else {
            attachEventHandler(".component.sitecore-form", "invalidForm", SitecoreContactID);
        }
        // to check invalid value for other product of interest - CE 6558
        if ($(".multiselect .dropbtn").length > 0) {
            multiselectDropdownCheck();
        }
    });

    function GTMEventTriggerOnFailure() {
        //set GTM on validation failure

        errorlst = "";
        $('.field-validation-error').each(function (index) {
            var errorMsgFor = $(this).attr("data-valmsg-for");
            var errorMsgField = $(".sitecore-form input[name='" + errorMsgFor + "'], textarea[name='" + errorMsgFor + "'], select[name='" + errorMsgFor + "']");
            if (errorlst.indexOf($(errorMsgField).attr("data-sc-field-name")) == -1 && (typeof $(errorMsgField).attr("data-sc-field-name") !== "undefined")) {
                errorlst = errorlst + "|" + $(errorMsgField).attr("data-sc-field-name");
            }
        });
        //remove the first "|"
        errorlst = errorlst.substring(1);
        if (typeof errorlst === "undefined") {
            errorlst = "";
        }
        if (gtmEventErrorKey === undefined && gtmEventErrorKey.length <= 0)
            gtmEventErrorKey = "customer_support_field_errors";

        var FieldError = {
            'eventLabel': errorlst
        };
        FieldError[gtmEventErrorKey] = errorlst;
        var GTMFailureContact = GTMFailureContactUS();
        var GTMOnFailure = $.extend(GTMFailureContact, FieldError);
        dataLayer.push(GTMOnFailure);
    }

    // function GTMEventTriggerOnSuccess(UpdatedSitecoreID) {
    //     var ContactUsGTM = GTMForContactUS(UpdatedSitecoreID);
    //     dataLayer.push(ContactUsGTM);
    // }

    function checkMsgLength() {
        // Your code or function to be invoked after 2 seconds
        decodeTextareaValue($(".ContactFormChemicals .encode-multiline"));
        $(".ContactFormChemicals .encode-multiline").css("color", "");
    }

    function checkshareformMsgLength() {
        // Your code or function to be invoked after 2 seconds
        var siteCoreFormData = $(".sitecore-form .encode-multiline");
        if (siteCoreFormData !== undefined) {
            siteCoreFormData.css("display", "block");
            siteCoreFormData.css("color", "transparent");
            decodeTextareaValue(siteCoreFormData);
            siteCoreFormData.css("color", "");
            // Get the values from data attributes
            var maxShareLength = parseInt(siteCoreFormData.data('val-length-max'));
            if (!isNaN(maxShareLength)) {
                var originalShareMessage = siteCoreFormData.next().text();
                if (originalShareMessage !== undefined) {
                    var newShareMaxLength = Math.floor(maxShareLength / 5);
                    var newShareMessageLength = originalShareMessage.replace(maxShareLength.toString(), newShareMaxLength.toString());
                    siteCoreFormData.next().text(newShareMessageLength);
                }
            }
        }
    }

    // changes S-31 surface item 
    $(function () {
        $('.surfaced-item-with-bgcolor').each(function () {
            var showMoreBtn,
                text,
                mask,
                expandBtn,
                collapseBtn;
            showMoreBtn = $(this).find('.truncate-btn');
            text = $(this).find('.surfaced-item-description');
            mask = $(this).find('.mask-gradient');
            expandBtn = $(this).find('.expand-btn');
            collapseBtn = $(this).find('.collapse-btn');
            if (showMoreBtn.length > 0) {
                if ($(window).width() < 480 && $(text).height() > 73) {
                    if ($(showMoreBtn).is(':empty')) {
                        $(text).css("height", 'auto');
                    }
                    else {
                        $(text).css("height", 65);
                    }
                    $(collapseBtn).css("display", "none");
                    $(expandBtn).on('click', function () {
                        $(text).css("height", 'auto');
                        $(mask).css("display", "none");
                        $(collapseBtn).css("display", "inline-block");
                        $(expandBtn).css("display", "none");
                    });
                    $(collapseBtn).on('click', function () {
                        $(text).css("height", 65);
                        $(mask).css("display", "block");
                        $(collapseBtn).css("display", "none");
                        $(expandBtn).css("display", "inline-block");
                    });
                } else if ($(text).height() === 65) {
                    return;
                } else {
                    $(showMoreBtn).css("display", "none");
                    $(mask).css("display", "none");
                }
            }
        });
    });



    function wrapInputs() {
        var radioChecks = $(".sitecore-form").find(".checkboxes label, .radio-buttons label");
        radioChecks.unwrap(".form-group").wrap("<div class='form-group'></div>");

        // Issue 1.16 Radio buttons are not combined in a group semantically issue.
        //commented as part of 10451 changes

        // var radioButtons = $('.form-radio-container');
        // $.each(radioButtons, function (index) {
        //     var label = $(radioButtons[index]);
        //     if ($(label).length > 0) {
        //         var labelAttr = $(label).attr("data-arialabel-text");
        //         if (labelAttr) {
        //             $(label).parent().eq(0).attr("role", "radiogroup").attr("aria-labelledby", labelAttr);
        //         }
        //     }
        // });

        $('.radio-buttons').each(function () {
            $(this).attr("role", "radiogroup");
            if ($(this).find('.labelRadioText').length > 0) {
                var completeLabelText = $($(this).find('.labelRadioText')[0]).text().trim();

                var ariaLabelText = completeLabelText.substring(0, completeLabelText.length - 1);

                $(this).attr("aria-label", ariaLabelText);
            }
        });

    }
    function wrapInlineInputs() {
        var radioChecks = $(".sitecore-form").find(".checkboxes.form-inline label, .radio-buttons label");
        radioChecks.unwrap(".form-group").wrap("<div class='form-group'></div>");

        // Issue 1.16 Radio buttons are not combined in a group semantically issue.
        //commented as part of 10451 changes

        // var radioButtons = $('.form-radio-container');
        // $.each(radioButtons, function (index) {
        //     var label = $(radioButtons[index]);
        //     if ($(label).length > 0) {
        //         var labelAttr = $(label).attr("data-arialabel-text");
        //         if (labelAttr) {
        //             $(label).parent().eq(0).attr("role", "radiogroup").attr("aria-labelledby", labelAttr);
        //         }
        //     }
        // });

        $('.radio-buttons').each(function () {
            $(this).attr("role", "radiogroup");
            if ($(this).find('.labelRadioText').length > 0) {
                var completeLabelText = $($(this).find('.labelRadioText')[0]).text().trim();
                var ariaLabelText = completeLabelText.substring(0, completeLabelText.length - 1);
                $(this).attr("aria-label", ariaLabelText);
            }
        });
    }

    function prepRequiredFields() {
        $('.sitecore-form label').each(function () {
            if ($(this).text().indexOf('*')) {
                var elhtml = $(this).html();
                var ehtml = elhtml.replace(/\*/g, '<span class="wep2-required">*</span>');
                $(this).html(ehtml);
            }
        });
    }

    function modalFormReset() {
        $(".modal button.btn-close, .modal-dialog .form-cancel").off("click.form.close").on("click.form.close", function () {
            resetActiveForm($(this).closest(".modal").find("form"));
        });

        $('body').off('click.form.close').on('click.form.close', '.form-btn-close', function () {
            resetActiveForm($(this).closest("form"));
        });

        $('.pds-share-link').on('click', function () {

            resetForm();
            $(".hdn-form-btn-close").click();
        });


    }
    function resetActiveForm(activeForm) {
        if (activeForm.length) {
            resetForm();
            $(activeForm).find(".hdn-form-btn-close").click();
        }
    }
    function resetForm() {
        var forms = $('.xom-form');
        for (var i = 0; i < forms.length; i++) {
            var formId = '#' + $(forms[i]).attr('id');
            if (formId) {
                var form = $(formId);
                if (form) {
                    var validator = form.validate();
                    if (validator) {
                        validator.resetForm();
                    }
                    $(formId + " .input-validation-error").addClass("valid");
                    $(formId + " .input-validation-error").removeClass("input-validation-error");
                    $(formId + " .field-validation-error").addClass("field-validation-valid");
                    $(formId + " .field-validation-valid").removeClass("field-validation-error");
                    $(formId + " .field-validation-valid").text('');
                    $(".field-validation-valid").text('');
                }
            }
        }
    }


    $('body').on('click', '.sfmc-form-databind',
        function () {
            prepRequiredFields();
        }
    );

    $('body').on('click', '.btn-remind-ps',
        function () {
            prepRequiredFields();
        }
    );

    $('body').on('click', '.field-description',
        function (e) {
            a14TargetElem = e.target;
            a14target = ".resource-list-description a:not([data-bs-toggle*=modal])";
        });

    $('body').on('click', '.field-linktext',
        function (e) {
            a14TargetElem = e.target;
            a14target = ".resource-list-action a:not([data-bs-toggle*=modal])";
        });

    function resetValidationOnFieldsUnderNotSelectedRadioGroup() {
        /* PSWEP-2170, 2645, 2680
           inputs indicating if a certain field is required (under Business / Customer) need to have the "disabled" attribute removed before submitting the form
           they get disabled when switching between radio buttons for dropdowns related to not selected radio button
           otherwise they are validated on sitecore side as required, even though they pass the client side validation
           and that causes the form to reload with a required message next to that field under the not chosen radio group
           it cannot be handled when switching between radios as sometimes the disabled attribute either reappeared or not disappeared soon enough (so was still there when submitting the form)
           Since the blocking issue is with disabled hidden fields, we traverse as such
           .xom-form > all inputs that are hidden and disabled and removed the disabled attribute from those fields
       */
        var disabledFields = $('.xom-form').find('input[type="hidden"][disabled]');
        $.each(disabledFields, function () {
            $(this).removeAttr("disabled");
        });

        /* PSWEP-2680 (in comments)
            In case a user selects one radio, fill in some of the data under it and attempts to submit the form, client validation prevents it from being sent to server.
            It adds some error classes and set the form's isSubmittedFlag attribute to true.
            Then if user switches to the other radio and fills in all data properly on that side, the added previously classes and isSubmittedFlag still prevents the form from being submitted
            To fix it, we need to remove isSubmittedFlag and update those error classes on the fields that are under a non-displayed form-group (that is the only way to recognize fields related to the not selected radio)
        */
        $(this).find(".modal-body .sitecore-form form").removeAttr("isSubmittedFlag");

        var hiddenFormGroup = $('.form-group').filter(function () {
            return $(this).css('display') == 'none';
        });

        $.each(hiddenFormGroup, function () {
            var fieldsWithErrors = $(this).find(".input-validation-error");
            $.each(fieldsWithErrors, function () {
                $(this).addClass("valid");
                $(this).removeClass("input-validation-error");
            });

            var validationMessageFields = $(this).find(".field-validation-error");
            $.each(validationMessageFields, function () {
                $(this).addClass("field-validation-valid");
                $(this).removeClass("field-validation-error");
                $(this).text('');
            });
        });
    }

    function bindEvents() {
        var $forms = $('.sitecore-form form');
        $("form select").off("blur").on("blur", function (e) {
            setTimeout(function () {
                // Accessibility - TFS bug 83246
                if (!$("#" + e.currentTarget.id + "-error").length) {
                    $("#" + e.currentTarget.id).removeAttr("aria-describedby");
                }
                /* for(var i=0;i< $('.sitecore-form input[type="checkbox"]').length ; i++){
                     if($('.sitecore-form input[type="checkbox"]')[i].getAttribute('aria-required') === 'False' || $('.sitecore-form input[type="checkbox"]')[i].getAttribute('aria-required') === 'false') {
                         var ele = $('.sitecore-form input[type="checkbox"]')[i];
                         ele.removeAttribute("aria-describedby");
                     } else {
                         var ele2 = $('.sitecore-form input[type="checkbox"]')[i];
                         ele2.setAttribute("aria-describedby",$('.sitecore-form input[type="checkbox"]')[i].getAttribute('name'));
                     }
                 } */
                // $("select").removeAttr("aria-describedby");
            }, 1000);
        });
        setTimeout(function () {
            $(".modal.fade.show .sitecore-form .form-area input.form-control").first().focus();
            // Accessibility - TFS bug 83246
            //  $("form select").removeAttr("aria-describedby");
        }, 1000);
        if ($(".modal.fade").hasClass('show')) {
            setTimeout(function () {
                // add all the elements inside modal which you want to make focusable
                var focusableElements = 'button:not(.d-none), [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';
                var modalID = $(".modal.fade.show").attr("id");
                for (var i = 0; i < $('.modal.fade').length; i++) {
                    if ($('.modal.fade')[i].getAttribute('id') && !$('.modal.fade')[i].getAttribute('aria-hidden') && $(".modal.fade").hasClass('show')) {
                        modalID = $(".modal.fade")[i].getAttribute("id");
                    }
                }
                if (modalID !== undefined) {

                    document.addEventListener('keydown', function (e) {
                        var modal = document.querySelector("#" + modalID); // select the modal by it's id
                        var firstFocusableElement = modal.querySelectorAll(focusableElements)[0]; // get first element to be focused inside modal
                        var focusableContent = modal.querySelectorAll(focusableElements);
                        var lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal

                        var isTabPressed = e.key === 'Tab' || e.keyCode === 9;
                        if (!isTabPressed) {
                            return;
                        }
                        if (e.shiftKey) { // if shift key pressed for shift + tab combination
                            if (document.activeElement === firstFocusableElement) {
                                lastFocusableElement.focus(); // add focus for the last focusable element
                                e.preventDefault();
                            }
                        } else { // if tab key is pressed
                            if (document.activeElement === lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
                                firstFocusableElement.focus(); // add focus for the first focusable element
                                e.preventDefault();
                            }
                        }
                    });
                    //firstFocusableElement.focus();
                    if ($("#" + modalID).hasClass('dr1vrs_club')) {
                        var width = $(document).width();
                        if (width >= 992) {
                            $(".modal.fade.show .sitecore-form input[type='text'].form-control").first().focus();
                        }
                    } else {
                        $(".modal.fade.show .sitecore-form input[type='text'].form-control").first().focus();
                    }
                    if ($("body").hasClass("modal-open")) {
                        $(".body-content").attr("aria-hidden", "true");
                        $("#footer").attr("aria-hidden", "true");
                    } else {
                        $(".body-content").removeAttr("aria-hidden");
                        $("#footer").removeAttr("aria-hidden");
                    }
                }
            }, 300);

        }

        $('body').on('submit', '.sitecore-form form', function (evt) {
            resetValidationOnFieldsUnderNotSelectedRadioGroup();

            //Form submit if used to bind in broader scope like body, will trigger multiple submit based on no of forms on the page
            if ($(".invalid-field").length > 0) {
                evt.preventDefault();
                evt.stopPropagation();
            } else if (!$(this).find(".form-btn-close:visible").length) {
                sanitizeFormInputs(evt);
                setTimeout(wrapInputs, 200);
            }
        });

        //Remove the attribute aria-describedby for the selectboxes inside forms
        $("body").on("click", "form [type='submit']", function () {
            //  $("form select").removeAttr("aria-describedby");
            setTimeout(function () {
                var selectBoxs = $("select[aria-describedby]");
                for (var j = 0; j < selectBoxs.length; j++) {
                    if ($(selectBoxs[j]).val() && $(selectBoxs[j]).val() !== "")
                        $(selectBoxs[j]).removeAttr("aria-describedby");
                }
            }, 1000);
        });
        //this code is to set delay timer on button, it will enable button after value specified in delay-timer button attribute
        $('body').off('shown.bs.modal').on('shown.bs.modal', '.modal', function (e) {
            $("form select").removeAttr("aria-describedby");
            $("form input").removeAttr("aria-describedby");
            $("form textarea").removeAttr("aria-describedby");
            $('.sitecore-form input[type="radio"]').removeAttr("aria-describedby");
            $('.sitecore-form input[type="checkbox"]').removeAttr("aria-describedby");
            setTimeout(wrapInputs, 200);
            $(this).find(".modal-body .sitecore-form form").attr("isSubmittedFlag", true);
            var submitButton = $(this).closest('.modal').find('.form-submit');
            if (submitButton != null && submitButton != 'undefined') {
                var isDelayEnabled = $(submitButton).attr('is-delay');
                var delayTimer = $(submitButton).attr('delay-timer');
                if (isDelayEnabled != null && delayTimer != null && isDelayEnabled != 'undefined' && delayTimer != 'undefined') {
                    $(submitButton).disabled = true;
                    $(submitButton).attr("disabled", "true");
                    setTimeout(function () { $(submitButton).disabled = false; $(submitButton).removeAttr("disabled"); }, delayTimer);
                }
            }
            bindEvents();
        });
        $('body').on('change', formInputs, resetXssCheck);



        $('.btn-close,.form-submit,.form-cancel').on('click', function () {
            $(".body-content").removeAttr("aria-hidden");
            $("#footer").removeAttr("aria-hidden");
            $(".dr1vrs_club").removeClass("success_modal");
            setTimeout(function () {
                for (var i = 0; i < $('.sitecore-form input').length; i++) {
                    if ($('.sitecore-form input')[i].getAttribute('aria-required') === 'False' || $('.sitecore-form input')[i].getAttribute('aria-required') === 'false') {
                        var ele = $('.sitecore-form input')[i];
                        ele.removeAttribute("aria-describedby");
                    }
                }
            }, 500);
            setTimeout(function () {
                for (var i = 0; i < $('.sitecore-form textarea').length; i++) {
                    if ($('.sitecore-form textarea')[i].getAttribute('aria-required') === 'False' || $('.sitecore-form textarea')[i].getAttribute('aria-required') === 'false') {
                        var ele = $('.sitecore-form textarea')[i];
                        ele.removeAttribute("aria-describedby");
                    }
                }
            }, 500);
            setTimeout(function () {
                for (var i = 0; i < $('.sitecore-form select').length; i++) {
                    if ($('.sitecore-form select')[i].getAttribute('aria-required') === 'False' || $('.sitecore-form select')[i].getAttribute('aria-required') === 'false') {
                        var ele = $('.sitecore-form select')[i];
                        ele.removeAttribute("aria-describedby");
                    }
                }
            }, 500);
            setTimeout(function () {
                for (var i = 0; i < $('.sitecore-form input[type="radio"]').length; i++) {
                    if ($('.sitecore-form input[type="radio"]')[i].getAttribute('aria-required') === 'False' || $('.sitecore-form input[type="radio"]')[i].getAttribute('aria-required') === 'false') {
                        var ele = $('.sitecore-form input[type="radio"]')[i];
                        ele.removeAttribute("aria-describedby");
                    }
                }
            }, 500);
            setTimeout(function () {
                for (var i = 0; i < $('.sitecore-form input[type="checkbox"]').length; i++) {
                    if ($('.sitecore-form input[type="checkbox"]')[i].getAttribute('aria-required') === 'False' || $('.sitecore-form input[type="checkbox"]')[i].getAttribute('aria-required') === 'false') {
                        var ele = $('.sitecore-form input[type="checkbox"]')[i];
                        ele.removeAttribute("aria-describedby");
                    }
                }
            }, 500);
        });
        // to check invalid value on mouse leave for other product of interest - CE 6558
        if ($(".multiselect .dropbtn").length > 0) {
            $(".multiselect .dropbtn").on('mouseleave', function () {
                multiselectDropdownCheck();
            });
        }
    }

    var globalAjaxRequestState = false;
    var lastSubmittedForm;
    var intervalId;
    var buttonElementText;
    var productNameInTitle;
    var angularObj;
    var isGalleryForm = false;
    var isGalleryFormSubmit = false;
    var galleryModalId;
    var isa14Form = false;
    var isa14FormSubmit = false;
    var a14formModalId;
    function sanitizeFormInputs(evt) {
        var $form = $(evt.target);
        galleryModalId = $form.attr("data-gallery-lock-id");
        if (($form.attr('data-gallery-locked-form')) == 'true') {
            isGalleryForm = true;
            isGalleryFormSubmit = true;
            var submitButtontext = $("#" + $form.attr("id") + "").find("input[type='submit']").val();
            angularObj = {
                "elementText": submitButtontext.toLowerCase() ? submitButtontext.toLowerCase() : undefined,
                "formName": getFormName($form),
                "formTitle": getFormTitle($form).toLowerCase(),
                "formDropdowns": getFormDropdowns($form),
                "parentName": getParentName($form).toLowerCase(),
                "parentTitle": getParentTitle(null, $form)
            };
        } else {
            isGalleryForm = false;
        }
        a14formModalId = $form.attr("data-a14-link-id");
        if (($form.attr('data-a14-form')) == 'true') {
            isa14Form = true;
            isa14FormSubmit = true;
        } else {
            isa14Form = false;
        }
        if ($("#" + $form.attr("id") + "").find("input:not([type='button']):visible").length) {
            lastSubmittedForm = $form.attr("id");
            productNameInTitle = $('#prodNameLabel').find('.dynamic-text:visible').text();
            var tempButtontext = $("#" + $form.attr("id") + "").find("input[type='submit']").val();
            angularObj = {
                "elementText": tempButtontext.toLowerCase() ? tempButtontext.toLowerCase() : undefined,
                "formName": getFormName($form),
                "formTitle": getFormTitle($form).toLowerCase(),
                "formDropdowns": getFormDropdowns($form),
                "parentName": getParentName($form).toLowerCase(),
                "parentTitle": getParentTitle(null, $form)
            };
            buttonElementText = angularObj.elementText.toLowerCase();
        } else {
            lastSubmittedForm = undefined;
            productNameInTitle = undefined;
        }

        if (!$form.attr('data-xss-checked')) {
            evt.preventDefault();
            evt.stopPropagation();
            var duplicatesFound = false;
            if ($form.find("[data-anti-spam-check]").length && $form.find("[data-anti-spam-check]").attr("data-anti-spam-check") === "True") {
                var availableTextFields = $(".modal-dialog form").find("input[type='text']:visible,input[type='Text']:visible,input[type='number']:visible,textarea:visible");
                var inputValuesArray = [];
                for (var i = 0; i < availableTextFields.length; i++) {
                    var tempValue = $(availableTextFields[i]).val();
                    if (tempValue.trim() !== "") {
                        inputValuesArray.push(tempValue.trim());
                    }
                }
                var uniqueValues = inputValuesArray.filter(function (el, index, arr) {
                    if (el.trim() !== "") {
                        return index === arr.indexOf(el.trim());
                    }
                });
                duplicatesFound = inputValuesArray.length !== uniqueValues.length;
            }



            if (!duplicatesFound && !$form.find('.input-validation-error').length && $form.valid()) {
                $form.attr('data-xss-checked', 'true');
                globalAjaxRequestState = true;
                if ($form.find('.form-sending').length) {
                    $('.modal.show .modal-content').append('<div class="modal-sending-backdrop"></div> ');
                    $('.modal.show').find('.modal-sending-backdrop').addClass('show');
                    $form.find('.form-sending').removeClass('d-none');
                    $form.find('.form-submit').addClass('d-none');
                }
                if ($form.find(".component.button-bar .duplicateErrorMessage").length) {
                    $form.find(".component.button-bar .duplicateErrorMessage").empty().remove();
                }
                $form.find(formInputs).each(function (i, field) {
                    if ($(field)[0].dataset.encode && $(field)[0].dataset.encode.toLowerCase() === 'true') {
                        $form.find(hiddenInputs).each(function (j, hiddenfield) {
                            var name = $(field)[0].dataset.scFieldName.toLowerCase();
                            if ($(hiddenfield)[0].dataset.scFieldName && (($(hiddenfield)[0].dataset.scFieldName.toLowerCase() === 'hdn' + name) && $(hiddenfield)[0].dataset.scFieldName.substring(3).toLowerCase() === name)) {
                                $(hiddenfield).val(encodeTextValue($(field).val()));
                                $(field).val(removeSpecialCharacters($(field).val(), [/\//, /\&/, /\-/, /\_/, /\!/, /\(/, /\)/, /\[/, /\]/, /\,/, /\;/, /\:/, /\./, /\*/, /\^/, /\~/, /\�/, /\+/, /\�/, /\"/, /\#/, /\$/, /\%/, /\=/, /\|/, /\�/, /\�/, /\'/, /\?/, /\@/, /\`/, /\{/, /\}/, /\�/, /\\/, /\&amp;/]));
                            }
                        });
                    }
                });
                $form.submit();
            }
            else if (duplicatesFound) {
                $form.find(".component.button-bar .duplicateErrorMessage").empty().remove();
                $form.find(".component.button-bar").last().prepend("<div class='text-danger duplicateErrorMessage'>" + $form.find("[data-anti-spam-message]").attr("data-anti-spam-message") + "</div>");
            }
            $form.find(formInputs).each(function (i, field) {
                $(field).val($.fn.xss.sanitize($(field).val()));
            });




        }
    }
    function showTickMark() {
        if ($(".icon_container").hasClass('hide_tick')) {
            $(".icon_container").removeClass("hide_tick");
            clearInterval(intervalId);
        }
    }
    $(document).ajaxSuccess(function (e, xhr, setting) {
        if (globalAjaxRequestState) {
            $('.modal.show').find('.modal-sending-backdrop').remove();


            globalAjaxRequestState = false;
        }

        wrapInlineInputs();
        if (xhr.status === 200 && xhr.responseText.indexOf("validation-summary-errors") == -1 && lastSubmittedForm && buttonElementText && $("#" + lastSubmittedForm + "")) {
            if ($('.lpg-form').length) {
                attachEventHandler(".component.sitecore-form", "OnFormSuccessfulSubmit", angularObj, $("#" + lastSubmittedForm + ""), buttonElementText);
            } else {
                attachEventHandler(".component.sitecore-form", "OnFormSuccessfulSubmit", angularObj, $("#" + lastSubmittedForm + ""));
            }

            //if (($(lastSubmittedForm).attr('data-gallery-locked-form')) == 'true') {
            //    setGalleryLockFeatureHandler(lastSubmittedForm);
            //}
            $('.form-btn-close').on('click', function () {
                $(".dr1vrs_club").removeClass("success_modal");
            });

            $(".success_anime").parents(".dr1vrs_club").addClass("success_modal");
            intervalId = setInterval(showTickMark, 500);
            // setTimeout(function () {
            //     $(".icon_container").removeClass("hide_tick");
            // }, 500);

            lastSubmittedForm = undefined;
            productNameInTitle = undefined;
            buttonElementText = undefined;
            angularObj = {};
        } else if (xhr.responseText.indexOf("validation-summary-errors") > -1) {

            clearTimeout(formTimer);
            formTimer = setTimeout(function () {
                $("#" + lastSubmittedForm + "").trigger('invalidForm');
                wrapInputs();
                if (xhr.responseText.indexOf("{prodNameLabel}") > -1) {
                    $('#prodNameLabel:visible').html(sanitizeHtmlStrings($('#prodNameLabel:visible').html().replace('{prodNameLabel}',
                        '<span class="dynamic-text">' + productNameInTitle + '</span>')));
                }
                lastSubmittedForm = undefined;
                productNameInTitle = undefined;
                buttonElementText = undefined;
                angularObj = {};
                // to keep charecter count after form submit
                if ($('.sitecore-form textarea').hasClass('character-count')) {
                    $("#charactercount").text($('.sitecore-form textarea.character-count')[0].value.length);
                }
            }, 1000);
            setTimeout(function () {
                checkshareformMsgLength();
            });
        }

        if (xhr.status === 200 && xhr.responseText.indexOf("validation-summary-errors") == -1 && isGalleryForm && isGalleryFormSubmit) {
            var formid = $(galleryModalId).find('form').attr('id');
            setGalleryLockFeatureHandler();
            attachEventHandler(".component.sitecore-form", "OnFormSuccessfulSubmit", angularObj, $("#" + formid + ""));
        }

        if (xhr.status === 200 && xhr.responseText.indexOf("validation-summary-errors") == -1 && isa14Form && isa14FormSubmit) {
            a14linkPDFDownloadHandler();
        }

        setTimeout(function () {
            if ($('.mobilsmilescheck:checked').length) {
                $(".mobilsmilescardno").parents(".form-area.form-group").show();
                $(".mobilsmilescardno").parents(".form-area.form-group").removeClass("d-none");
            }
            else {
                $(".mobilsmilescardno").parents(".form-area.form-group").hide();
                $(".mobilsmilescardno").parents(".form-area.form-group").addClass("d-none");
            }
            $('.sitecore-form form').off('invalid-form.validate');
            $('.sitecore-form form').on('invalid-form.validate', function () {
                var $form = $(this);
                // Since multiple validation events may happen based on the form config, roll them up to one event
                clearTimeout(formTimer);
                formTimer = setTimeout(function () {
                    $form.trigger('invalidForm');
                }, 1000);
            });
        }, 1000);

    });
    function resetXssCheck(evt) {
        $form = $(evt.target).removeAttr('data-xss-checked');
    }

    function setGalleryLockFeatureHandler() {
        var id = galleryModalId;
        videoId.push(id);
        isGalleryForm = false;
        isGalleryFormSubmit = false;
        sessionStorage.setItem("videoId", JSON.stringify(videoId));
        $('.gallery-inner.wep-gallery .row a.video-link-item').each(function () {
            var targetid = $(this).attr('data-bs-target');
            var targetsrc = $(this).attr('data-src');
            if (targetid == id) {
                $(targetid).attr('data-video-locked', false);
                var iframeObjtarget = $(targetid).find('iframe');
                $(iframeObjtarget).css('display', 'block');
                $(targetid).find('.modal-body').css('background-color', 'transparent');
                $(targetid).find('form').remove();
                $(targetid).find('.embed-responsive-16by9').removeClass('embed-form-iframe');
                $(id).find('.embed-responsive-16by9').addClass('embed-responsive');
                var targetclass = $(this).find('.fa-lock').attr('data-video-icon-class');
                $(this).find('.fa-lock').addClass(targetclass);
                $(this).find('.fa-lock').removeClass('fa-2x');
                $(this).find('.fa-lock').css('top', '50%');
                $(this).find('.fa-lock').css('left', '50%');
                $(this).find('.fa-lock').removeClass('fa-lock');
                if ($(iframeObjtarget).attr('data-autoplay-enabled') === 'True') {
                    $(this).siblings().children().find('.modal-content').css('background-color', 'transparent');
                    var videosrc = $(iframeObjtarget).attr('data-original-src');
                    addParamstoGalleryVideos(videosrc, iframeObjtarget);
                    // $(iframeObjtarget).attr('src', videosrc);
                }
                else {
                    $(this).siblings().children().find('.modal-content').css('background-color', 'transparent');
                    addParamstoGalleryVideos(src, iframeObjtarget);
                    // $(iframeObjtarget).attr('src', targetsrc);
                }
            }
        });
    }

    function a14linkPDFDownloadHandler() {
        var targethref = $(a14formModalId).attr('data-href');

        var a14session = sessionStorage.getItem('a14formId');

        if (a14session == null) {
            var a14sessionId = [];
            a14sessionId.push(a14formModalId);
            sessionStorage.setItem("a14formId", JSON.stringify(a14sessionId));
        } else {
            a14session = JSON.parse(a14session);
            a14session.push(a14formModalId);
            sessionStorage.setItem("a14formId", JSON.stringify(a14session));
        }

        var link = document.createElement('a');
        link.setAttribute('href', sanitizeHtmlStrings(targethref));
        link.click();
        isa14Form = false;
        isa14FormSubmit = false;
        attachEventHandler(".component.a14-resource-list", a14target, angularObj, a14TargetElem);

        $('.a14-form-link').each(function () {
            var targetid = $(this).attr('data-bs-target');
            var targethref = $(this).attr('data-href');

            if (targetid == a14formModalId) {
                $(this).attr('href', targethref);
                $(this).attr('data-bs-toggle', '');
            }
        });
    }

    // LPG form changes

    $(document).ready(function () {
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0');
        var yyyy = today.getFullYear();
        today = yyyy + '-' + mm + '-' + dd;
        $('.lpg-form-slot').attr('disabled', true);
        var isToday, minDate, tommorowDate;
        if ($(".lpg-form-date").length) {
            isToday = document.querySelector(".lpg-form-date").getAttribute("data-sc-today-date-bool");
            minDate = document.querySelector(".lpg-form-date").getAttribute("min");
            var todayVal = new Date(minDate);
            var day;
            if (todayVal.getDate() == new Date(todayVal.getFullYear(), todayVal.getMonth() + 1, 0).getDate()) {
                todayVal.setMonth(todayVal.getMonth() + 1, 1);
                tommorowDate = todayVal;
                day = tommorowDate.getDate();
            } else {
                tommorowDate = new Date(minDate);
                day = tommorowDate.getDate() + 1;
            }
            //   var day = tommorowDate.getDate() + 1;
            var month = tommorowDate.getMonth() + 1;
            var year = tommorowDate.getFullYear();
            if (!$('.lpg-form-date').val()) {
                $('.lpg-form-slot').attr('disabled', true);
            } else {
                $('.lpg-form-slot').removeAttr('disabled');
            }
            if (day < 10) {
                day = '0' + day;
            }
            if (month < 10) {
                month = '0' + month;
            }
            tommorowDate = year + '-' + month + '-' + day;
            initializeLPGFormData();
        }
        function initializeLPGFormData() {
            if (isToday.toLowerCase() !== 'true') {
                document.querySelector(".lpg-form-date").min = tommorowDate;
            }

        }
        function handler() {
            $('.lpg-form-slot').removeAttr('disabled');
            var todayTime = document.querySelector(".lpg-form-date").getAttribute("data-sc-time-in-hour");
            var getAMPM = document.querySelector(".lpg-form-date").getAttribute("data-sc-time-in-designator");
            if (getAMPM == 'PM' && todayTime < 12) {
                todayTime = parseInt(todayTime) + 12;
            } else if (getAMPM == 'AM' && todayTime == 12) {
                todayTime = parseInt(todayTime) - 12;
            }
            var dataInput = document.querySelector(".lpg-form-date");
            var currentDate = dataInput.value;
            var todayDate = new Date();
            var nextDate = new Date(currentDate);
            var diff_in_days = (nextDate.getTime() - todayDate.getTime()) / (1000 * 60 * 60 * 24);
            if (currentDate == today) {
                currentTime();
            }
            else if (currentDate > today && diff_in_days <= 1 && isToday.toLowerCase() !== 'true') {
                currentTime();
            } else if (currentDate > today && diff_in_days > 1) {
                $(".lpg-form-slot").children().removeAttr("disabled");
            }
            function currentTime() {
                var counter = 0;
                $(".lpg-form-slot").children().each(function () {
                    var strOpt = $(this).attr("value");
                    var timeSplit = strOpt.split("-");
                    startTime = timeSplit[0].trim();
                    //endTime = timeSplit[0].trim();

                    var checkAmPm = startTime.replace(/\d+/g, '');

                    var hours = startTime.replace(checkAmPm, "");

                    if (checkAmPm == "PM" && hours < 12) hours = parseInt(hours) + 12;
                    if (checkAmPm == "AM" && hours == 12) hours = parseInt(hours) - 12;
                    if (hours < 10) {
                        hours = '0' + hours;
                    }
                    if (todayTime >= hours) {
                        $(this).prop("disabled", "true");

                    } else {
                        counter++;
                    }
                });
                if (counter === 0) {
                    document.querySelector(".lpg-form-date").value = tommorowDate;
                    $(".lpg-form-slot").children().removeAttr("disabled");
                }


            }
        }

        $(".lpg-form-date").change(function () {
            handler();
        });
    });

    // removing aria-described for input fields with errors even for valid input
    $(document).ready(function () {
        function removedAriaAttribute(e) {
            setTimeout(function () {
                if (e.currentTarget.id) {
                    if (!$("#" + e.currentTarget.id + "-error").length) {
                        $("#" + e.currentTarget.id).removeAttr("aria-describedby");
                    }
                }

            }, 500);
        }
        $('.sitecore-form input').focusout(function (e) {
            if ($(e.currentTarget).attr("type") && $(e.currentTarget).attr("type").toLowerCase() !== "checkbox" && $(e.currentTarget).attr("type").toLowerCase() !== "radio") {
                removedAriaAttribute(e);
            }
        });

        $('.sitecore-form input').focusin(function (e) {
            if ($(e.currentTarget).attr("type") && $(e.currentTarget).attr("type").toLowerCase() !== "checkbox" && $(e.currentTarget).attr("type").toLowerCase() !== "radio") {
                removedAriaAttribute(e);
            }
        });

        $('.sitecore-form input').focus(function (e) {
            if ($(e.currentTarget).attr("type") && $(e.currentTarget).attr("type").toLowerCase() !== "checkbox" && $(e.currentTarget).attr("type").toLowerCase() !== "radio") {
                removedAriaAttribute(e);
            }
        });
        $('.sitecore-form input').on('keypress keyup keydown', function (e) {
            if ($(e.currentTarget).attr("type") && $(e.currentTarget).attr("type").toLowerCase() !== "checkbox" && $(e.currentTarget).attr("type").toLowerCase() !== "radio") {
                removedAriaAttribute(e);
            }
        });


        $('.sitecore-form textarea').focusout(function (e) {
            removedAriaAttribute(e);
        });

        $('.sitecore-form textarea').focusin(function (e) {
            removedAriaAttribute(e);
        });

        $('.sitecore-form textarea').focus(function (e) {
            removedAriaAttribute(e);
        });
        $('.sitecore-form textarea').change(function (e) {
            removedAriaAttribute(e);
        });
        $('.sitecore-form textarea').on('keypress keyup keydown', function (e) {
            removedAriaAttribute(e);
        });

        $('.sitecore-form select').focusout(function (e) {
            removedAriaAttribute(e);
        });

        $('.sitecore-form select').focusin(function (e) {
            removedAriaAttribute(e);
        });

        $('.sitecore-form select').focus(function (e) {
            removedAriaAttribute(e);
        });
        $('.sitecore-form select').change(function (e) {
            removedAriaAttribute(e);
        });

        function removedAriaAttributeForRadio(e) {
            setTimeout(function () {
                for (var i = 0; i < $('.sitecore-form input[type="radio"]').length; i++) {
                    if (e.target.name === $('.sitecore-form input[type="radio"]')[i].name && $('.sitecore-form input[type="radio"]')[i].className === 'valid') {
                        var ele = $('.sitecore-form input[type="radio"]')[i];
                        ele.removeAttribute("aria-describedby");
                    } else {
                        if (e.target.name === $('.sitecore-form input[type="radio"]')[i].name && $('.sitecore-form input[type="radio"]')[i].className === 'input-validation-error') {
                            var ele2 = $('.sitecore-form input[type="radio"]')[i];
                            ele2.setAttribute("aria-describedby", $('.sitecore-form input[type="radio"]')[i].name + '-error');
                        }
                    }
                }
            }, 500);
        }
        function removedAriaAttributeForCheckbox(e) {
            setTimeout(function () {
                for (var i = 0; i < $('.sitecore-form input[type="checkbox"]').length; i++) {
                    if (e.target.name === $('.sitecore-form input[type="checkbox"]')[i].name && $('.sitecore-form input[type="checkbox"]')[i].className === 'valid') {
                        var ele = $('.sitecore-form input[type="checkbox"]')[i];
                        ele.removeAttribute("aria-describedby");
                    } else {
                        if ((e.target.name === $('.sitecore-form input[type="checkbox"]')[i].name && $('.sitecore-form input[type="checkbox"]')[i].className === 'input-validation-error')) {
                            var ele2 = $('.sitecore-form input[type="checkbox"]')[i];
                            ele2.setAttribute("aria-describedby", $('.sitecore-form input[type="checkbox"]')[i].name + '-error');
                        }
                    }
                }
            }, 1000);
        }


        $('body').click('.sitecore-form input[type="radio"]', function (e) {
            removedAriaAttributeForRadio(e);
        });


        $('body').click('.sitecore-form input[type="checkbox"]', function (e) {
            removedAriaAttributeForCheckbox(e);
        });


        $('body .sitecore-form input[type="checkbox"]').focus(function (e) {
            removedAriaAttributeForCheckbox(e);
        });

        $('body .sitecore-form input[type="radio"]').focus(function (e) {
            removedAriaAttributeForRadio(e);
        });
    });

    function encodeTextValue(inputTxt) {
        var formattedTxt = "";

        var i = 0;
        while (i < inputTxt.length) {
            if (inputTxt[i] == " " || inputTxt[i] == "\r" || inputTxt[i] == "\n" || inputTxt[i] == "\r\n") {
                formattedTxt += inputTxt[i];
                i++;
            } else {
                var chr = inputTxt.charCodeAt(i++);
                if (chr >= 0xD800 && chr <= 0xDBFF) {
                    // surrogate pair
                    var low = inputTxt.charCodeAt(i++);
                    formattedTxt += ("0000000" + (0x10000 + ((chr - 0xD800) << 10) | (low - 0xDC00)).toString(16)).substr(-8);
                } else {
                    // ordinary character
                    formattedTxt += ("0000000" + chr.toString(16)).substr(-8);
                }
            }
        }
        return formattedTxt;
    }
    function multiselectDropdownCheck() {
        if ($(".multiselect .dropdown-content").length > 0) {
            var dlen = $(".multiselect .dropdown-content").find("label").length;
            var arrDropDown = [];
            for (var k = 1; k < dlen; k++) {
                var checkVal = $(".multiselect .dropdown-content").find("label input")[k].checked;
                if (checkVal) {
                    var valdata = $(".multiselect .dropdown-content").find("label input")[k].value;
                    arrDropDown.push(valdata);
                }
            }
            var newval = arrDropDown.join(", ");
            $(".multiselect .dropbtn").val(newval);
        }
    }
    function removeSpecialCharacters(retStr, replace) {
        for (var i = 0; i < replace.length; i++) {
            retStr = retStr.replace(new RegExp(replace[i], 'g'), '');
        }
        return retStr;
    }
}(window.jQuery));

(function () {
    $(window).on("load", initalURLString);
    function initalURLString() {
        var prepopulated = false;
        var urldecodedValue = "";

        var selectElms = document.querySelectorAll('select');
        if (selectElms.length > 0) {
            var selectArr = Array.from(selectElms);
            selectArr.forEach(function (selectValue) {
                var matchedData = selectValue.getAttribute('data-sc-field-name');
                if (matchedData == 'Primary_Product_of_Interest__c') {

                    if (window.location.href.indexOf('?') > -1) {
                        var urlValue = window.location.href.split("?");
                        if (urlValue.length > 1) {
                            var listUrlValue = urlValue[1];
                            if (listUrlValue !== '') {
                                var splitUr1Value = listUrlValue.split('=');
                                if (splitUr1Value.length > 1 && splitUr1Value[0] == "ppoi") {
                                    urldecodedValue = decodeURI(splitUr1Value[1]);

                                    var selectedMatch = selectValue;
                                    var selectedopt = selectedMatch.options;
                                    var selectedArr = Array.from(selectedopt);
                                    selectedArr.forEach(function (optval) {
                                        if (optval.value == urldecodedValue) {
                                            prepopulated = true;
                                        }
                                    });
                                    if (prepopulated) {
                                        selectedArr.forEach(function (optval) {
                                            if (optval.value == urldecodedValue) {
                                                $(selectedMatch).val(urldecodedValue).trigger("change");
                                            }
                                            else if (optval.value != urldecodedValue) {
                                                selectedMatch.removeChild(optval);
                                            }
                                        });
                                    }
                                }
                            }
                        }
                    }
                }

            });
        }
    }
}(window.jQuery));


(function ($) {
    $(document).ready(function () {
        $('.select-dropdown-link select').on('change', function () {
            var redirect_url = $(this).val();
            if ($(this).find('option:selected').attr('linktype') === 'external') {
                window.open(sanitizeHtmlStrings(redirect_url), '_blank');
            } else {
                document.location.href = window.encodeURI(sanitizeHtmlStrings(decodeURI(redirect_url)));
            }
        });
    });
}(window.jQuery));
(function ($) {
    $(document).ready(function () {
        $("form .open-contact-us").on("click", function () {
            var selectedVal = $('#ddlformName').val();
            if (selectedVal == '' || selectedVal == '0') {
                alert('please select from from the list');
                return false;
            }
            var url = $('form').attr('action') + "?formid=" + selectedVal;
            window.location.href = sanitizeHtmlStrings(url);

        });
    });

}(window.jQuery));